import defaultSource from "./defaultSource";
import irwinHall from "./irwinHall";

export default (function sourceRandomBates(source) {
  function randomBates(n) {
    var randomIrwinHall = irwinHall.source(source)(n);
    return function() {
      return randomIrwinHall() / n;
    };
  }

  randomBates.source = sourceRandomBates;

  return randomBates;
})(defaultSource);



//////////////////
// WEBPACK FOOTER
// /srv/scratch/old-home/dyall/trinity/trinity-frontend-master/~/d3-random/src/bates.js
// module id = ../../../../d3-random/src/bates.js
// module chunks = 3